// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tj-0";